const API_BASE_URL = process.env.REACT_APP_RECRUIT_API_URL || 'http://localhost:8080';

async function recordVisit(targetType, targetId) {
    const today = new Date().toLocaleDateString('sv-SE'); // YYYY-MM-DD, 한국 로컬 시간 기준
    const key = `visit_${targetType}_${targetId ?? 'SITE'}_${today}`;
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, '1');

    try {
        await fetch(`${API_BASE_URL}/api/visits`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ targetType, targetId }),
        });
    } catch (e) {
        // 조회수 집계 실패는 사용자 경험에 영향 없음
    }
}

async function getJobPostVisitCount(id) {
    const response = await fetch(`${API_BASE_URL}/api/visits/job-posts/${id}`);
    if (!response.ok) throw new Error('Failed to fetch visit count');
    return response.json();
}

async function getVisitStats(from, to) {
    const params = new URLSearchParams({ from, to });
    const response = await fetch(`${API_BASE_URL}/api/visits/stats?${params}`);
    if (!response.ok) throw new Error('Failed to fetch visit stats');
    return response.json();
}

export const siteVisitRepository = {
    recordVisit,
    getJobPostVisitCount,
    getVisitStats,
};
